import { create } from 'zustand'
import api from '../services/api'

export type PermissionAction = 'view' | 'create' | 'edit' | 'delete' | 'approve' | 'send'
export type PermissionModule = 'offerte' | 'commesse' | 'schede' | 'anagrafiche' | 'magazzino' | 'fascicoli' | 'calendario' | 'scadenziario' | 'configurazione'

export type Permissions = Record<string, string[]>

interface PermissionState {
  permissions: Permissions | null
  isLoaded: boolean

  loadPermissions: () => Promise<void>
  hasPermission: (module: PermissionModule, action: PermissionAction) => boolean
  clearPermissions: () => void
}

export const usePermissionStore = create<PermissionState>((set, get) => ({
  permissions: JSON.parse(localStorage.getItem('erp_permissions') || 'null'),
  isLoaded: !!localStorage.getItem('erp_permissions'),

  loadPermissions: async () => {
    try {
      const response = await api.get('/v1/auth/me')
      const perms = response.data.permissions || null

      if (perms) {
        localStorage.setItem('erp_permissions', JSON.stringify(perms))
      }

      set({ permissions: perms, isLoaded: true })
    } catch {
      set({ permissions: null, isLoaded: true })
    }
  },

  hasPermission: (module: PermissionModule, action: PermissionAction): boolean => {
    const { permissions } = get()
    if (!permissions) return false

    const modulePerms = permissions[module]
    if (!modulePerms) return false

    return modulePerms.includes(action)
  },

  clearPermissions: () => {
    localStorage.removeItem('erp_permissions')
    set({ permissions: null, isLoaded: false })
  },
}))
